/**
 * Wrapper route for sites served on a custom domain. It hydrates the shared
 * landing page container with custom-domain metadata and conditionally surfaces
 * invitation messaging for collaborators entering through branded URLs.
 *
 * Key responsibilities:
 * - Initialize {@link LandingPageContainer} with a `customDomain` source so the
 *   downstream layout can load published content and theme assets.
 * - Surface invitation context via {@link useInvitation} to handle multi-user
 *   onboarding experiences for teams.
 * - Coordinate dismissal of the invitation banner without leaking state across
 *   renders of the core landing experience.
 */
import LandingPageContainer from "@/components/landingPage/common/LandingPageContainer";
import { InvitationBanner } from "@/components/shared/InvitationBanner";
import { useInvitation } from "@/components/landingPage/hooks/useInvitation";

const CustomDomainLandingPage = () => {
  const { invitation, showInvitationBanner, setShowInvitationBanner } = useInvitation();

  return (
    <LandingPageContainer source={{ type: "customDomain" }}>
      {showInvitationBanner && invitation && (
        <InvitationBanner invitation={invitation} onDismiss={() => setShowInvitationBanner(false)} />
      )}
    </LandingPageContainer>
  );
};

export default CustomDomainLandingPage;